module.exports = __webpack_public_path__ + "media/images/core_values/loyalty-2f7e17c0bb997ee11abc13f5e71b448c.png";